<script lang="ts" setup>
import { NxtInput, NxtPhoneNumberInput } from '@future-harry/nxt-styles';
import NxtAddressField from '@/core/components/form-elements/NxtAddressField.vue';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { useSettingsStore } from '@/apps/admin/stores/settings.store';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });

const settingsStore = useSettingsStore();
const jobBoardSettingsErrors = computed(() => settingsStore.validationErrors.value);
</script>

<template>
   <section class="address-form">
      <div class="row">
         <NxtAddressField v-model="jobBoard.address" name="official_address" />
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput
               :label="$t('job-board.settings.email')"
               v-model="jobBoard.contact_email"
               name="contact_email"
               type="email"
               :errors="jobBoardSettingsErrors"
            />
         </div>
         <div class="col-half">
            <NxtPhoneNumberInput
               :label="$t('job-board.settings.phone_number')"
               v-model="jobBoard.address.phone_number"
               name="settings_phone_number"
            />
         </div>
      </div>
   </section>
</template>

<style lang="scss" scoped>
.address-form {
   :deep(.nxt-address) {
      background-color: transparent;
      padding: 0;

      input {
         background-color: var(--nxt-extralight-grey);
      }

      .nxt-address__heading {
         display: none;
      }

      .nxt-address__city {
         grid-column-start: 1;
         grid-column-end: 5;
      }
   }
}
</style>
